// extracted by mini-css-extract-plugin
export default {"slide_title":"SlideTitle_slide_title__182Kg"};